import React, { useCallback } from 'react'
import { PanelHeader } from '../../../../components/PanelHeader/PanelHeader';
import { PanelFooter } from '../../../../components/PanelFooter/PanelFooter';
import { MessageBar, MessageBarType, Panel, PanelType } from '@fluentui/react';
import { IOpenPanel } from '../../../../interfaces/base/IPanel';
import { MessageBarResponse } from "../../../../components/MessageBar/MessageBarResponse";
import { UseGuardiaEliminar } from './UseGuardiaEliminar';
import { ProgressBarLoading } from '../../../../components/ProgressBarLoading/ProgressBarLoading';
import { IGuardia } from '../../../../interfaces/IGuadia';


export interface IPanelGuardiaEliminar extends IOpenPanel {
    guardiaData: IGuardia
}

const PanelGuardiaEliminar = (props: IPanelGuardiaEliminar) => {

    const { request, deleteRoster, loading, reset, mensaje, status, nuevo } = UseGuardiaEliminar(props)

    const onRenderHeader = useCallback(
        () => (
            <>
                <PanelHeader
                    nameIconHeader="delete"
                    textHeader={`Guardia Programación`}
                    subTextHeader={`Eliminar guardia`}
                />
            </>
        ),
        []
    );

    const onRenderFooter = useCallback(
        () => (
            <>
                <PanelFooter
                    texto="Eliminar"
                    onClick={deleteRoster}
                    onDismiss={reset}
                />
            </>
        ), [request]
    );
    const onRenderFooter2 = useCallback(
        () => (
            <>
                <PanelFooter
                    texto="Salir"
                    onClick={reset}
                    oneButton={true}
                    // onDismiss={reset}
                />
            </>
        ), [request]
    );

    return (
        <>
            <Panel
                type={PanelType.smallFixedFar}
                onRenderHeader={onRenderHeader}
                onRenderFooter={(!loading && mensaje == "") ? onRenderFooter : onRenderFooter2}
                isFooterAtBottom
                isOpen={props.isOpen}
                onDismiss={reset}
            >
                <div hidden={mensaje == ""}>
                    <MessageBarResponse
                        objetoResponse={{ codigo: status, mensaje: mensaje }}
                        close={true}
                    />
                </div>
                <div hidden={!loading}>
                    <ProgressBarLoading ></ProgressBarLoading>
                </div>
                <div hidden={loading || mensaje != ""}>
                    <MessageBar
                        delayedRender={false}
                        messageBarType={MessageBarType.severeWarning}
                    >
                        ¿Seguro que quieres eliminar la guardia:<strong> {props.guardiaData?.codigo}</strong>?
                    </MessageBar>
                </div>
            </Panel>
        </>
    )
}

export { PanelGuardiaEliminar }